let content = [
    {
      id: "general_trading_conditions",
      title: "เงื่อนไขการเทรดทั่วไป",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "รายละเอียดผลิตภัณฑ์",
          content_before: `<p class="mb-5">
                           iFOREX เสนอเงื่อนไขการแข่งขันสูงสำหรับเครื่องมือทางการเงินต่อไปนี้ (“เครื่องมือทางการเงิน” หรือ “ตราสาร”) (i) การซื้อขายมาร์จิ้นที่ใช้ประโยชน์จากเครื่องมือทางการเงิน / สินทรัพย์อ้างอิง (“สินทรัพย์อ้างอิง”) รวมถึงคู่สกุลเงิน (ฟอเร็กซ์), สินค้าโภคภัณฑ์, ดัชนี, หุ้น , CFD ที่ใช้ ETF และ Crypto (“Leveraged Instruments” หรือ “CFDs”) และ (ii) ผลิตภัณฑ์การซื้อขายที่ไม่มีเลเวอเรจ
                            <br><br>
                            <b>สเปรด</b><br>สเปรด (Spread) คือต้นทุนการเทรด ซึ่งก็คือส่วนต่างระหว่างราคาขาย (ราคาที่รับซื้อ (bid)) และราคาซื้อ (ราคาที่ขาย (ask)) ตัวอย่างเช่น หากกำลังมีการเทรด USD/JPY ที่ราคาขายที่ 101.202 และราคาซื้อที่ 101.222 ส่วนต่างระหว่างราคาสองราคานี้เรียกว่าสเปรด ซึ่งในกรณีนี้ สเปรดเท่ากับ 2 pip
                            <br><br>
                            <b>มาร์จิ้นและเลเวอเรจ</b><br>เมื่อเทรดตราสารที่มีเลเวอเรจ แม้ว่า “มาร์จิ้น (Margin)” จะทำหน้าที่เป็นหลักประกันที่ครอบคลุมการขาดทุนทั้งหมดที่อาจเกิดขึ้นกับคุณ แต่มาร์จิ้นยังทำให้คุณสามารถถือสถานะที่มีมูลค่าสูงกว่ามูลค่าจริงในบัญชีของคุณ ทำให้คุณมีโอกาสที่จะสร้างผลกำไรจำนวนมากเมื่อเทียบกับจำนวนเงินที่ลงทุน
                            <br><br>
                            เลเวอเรจ (Leverage) คือดาบสองคมและสามารถเพิ่มผลกำไรของคุณได้เป็นอย่างมาก อย่างไรก็ตาม เลเวอเรจก็สามารถเพิ่มการขาดทุนของคุณได้ง่ายพอ ๆ กัน เมื่อคุณใช้เลเวอเรจมากเกินไป การเทรดขาดทุนสามารถลบล้างการเทรดได้กำไรได้อย่างรวดเร็ว การเทรดที่มีเลเวอเรจมีความเสี่ยงสูง และอาจไม่เหมาะสำหรับนักลงทุนทุกคน
                            <br><br>
                            ในฐานะผู้ถือบัญชี iFOREX คุณมีสิทธิ์ที่จะเข้าร่วมโปรแกรมการป้องกันยอดคงเหลือเป็นลบ ซึ่งหมายความว่าคุณไม่มีทางที่จะขาดทุนมากกว่าจำนวนเงินที่คุณได้ฝากเข้าบัญชี แต่อย่างไรก็ตาม การเคลื่อนไหวเล็กน้อยในตลาดก็อาจส่งผลให้เกิดการขาดทุนจำนวนมาก แพลตฟอร์มการเทรดของเราคำนวณมาร์จิ้นที่คุณจำเป็นต้องใช้ก่อนดำเนินการตามคำสั่งใด ๆ โดยอัตโนมัติ และตรวจสอบระดับเงินทุนที่มีก่อนที่จะมีการดำเนินการตามคำขอถอนเงินใด ๆ
                            <br><br>
                           The margin requirements are relevant upon increasing Exposure in the account, either by opening/closing deals or by requesting to withdraw funds while having open positions in the account. The margin requirements reflect the potential risk in positions, based on volatility, liquidity and pricing availability, in any given asset.
                            </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/เงื่อนไขการเทรด/สกุลเงิน">สกุลเงิน</a></p>
                            <p class="tc-inner-link"><a href="/เงื่อนไขการเทรด/สินค้าโภคภัณฑ์">สินค้าโภคภัณฑ์</a></p>
                            <p class="tc-inner-link"><a href="/เงื่อนไขการเทรด/ดัชนี">ดัชนี</a></p>
                            <p class="tc-inner-link"><a href="/เงื่อนไขการเทรด/หุ้น">หุ้น</a></p>
                            <p class="tc-inner-link"><a href="/เงื่อนไขการเทรด/etfs">ETFs</a></p>
                            <p class="tc-inner-link"><a href="/เงื่อนไขการเทรด/สกุลเงินตราเข้ารหัสลับ">สกุลเงินคริปโต</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "ชั่วโมงซื้อขาย",
          content_before: `<p>
                        ในระหว่างฤดูหนาวในยุโรปและอเมริกาเหนือ กิจกรรมในแต่ละสัปดาห์จะเริ่มต้นในวันอาทิตย์ เวลา 22:05 น. ตามเขตเวลา GMT ต่อเนื่องไปจนถึงวันศุกร์ เวลา 21:00 น. ตามเขตเวลา GMT ในระหว่างช่วงเวลาฤดูร้อนในภูมิภาคเหล่านี้ กิจกรรมในแต่ละสัปดาห์จะเริ่มต้นในวันอาทิตย์ เวลา 21:05 น. ตามเขตเวลา GMT และสิ้นสุดในวันศุกร์ เวลา 20:00 น. ชั่วโมงทำการของตลาดอาจแตกต่างออกไปขึ้นอยู่กับวันหยุดราชการ หรือเนื่องจากสภาพคล่องที่ไม่ปกติซึ่งอาจเกิดขึ้นจากเหตุการณ์ผิดปกติระดับโลก นอกจากนี้ iFOREX อาจเปลี่ยนแปลงเวลาเปิดหรือเวลาปิดการซื้อขายเนื่องจากข้อพิจารณาเกี่ยวกับสภาพคล่องและการบริหารจัดการความเสี่ยง
                        <br><br>
                        ถึงแม้ว่าตราสารส่วนใหญ่จะมีการซื้อขายกันเป็นราย 24 ชั่วโมงโดยไม่มีการหยุดชะงัก แต่อย่างไรก็ตาม ตราสารบางอย่างมีชั่วโมงซื้อขายพิเศษ ดังจะเห็นได้ในตารางด้านล่าง:
                        </p>`,
  
          data_id: "TradingHours",

          products: {
            1:"สกุลเงินและคริปโต",
            2:"สินค้าโภคภัณฑ์",
            3:"ดัชนี",
            4:"หุ้น",
            5:"Metals",
            8:"ETF"
          },
          table_titles: [
            "ตลาด",
            "เวลาซื้อขาย (GMT)",
            "เวลาหยุดพักการซื้อขายครั้งที่ 1 ของวัน (GMT)",
            "เวลาหยุดพักการซื้อขายครั้งที่ 2 ของวัน (GMT)",
            "ข้อมูลถูกต้องจนถึง (GMT)"
          ],
          content_after: `<p>ไม่แน่ใจว่าตลาดมีตราสารที่คุณกำลังมองหาอยู่หรือไม่? คลิก<span class="tclink" target-tab="tc-view-6">ที่นี่</span>เพื่อดูรายการตราสารทั้งหมดตามรายตลาด</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "วันหยุด",
          content_before: `<p>
                            เพื่อให้แน่ใจว่าคุณทราบเวลาทำการซื้อขายและวันหยุดทั้งหมด โปรดดูรายการเหตุการณ์ที่อาจเปลี่ยนแปลงชั่วโมงซื้อขายด้านล่าง<br>
                            ที่ iFOREX เราใช้ความพยายามอย่างเต็มที่เพื่อที่จะปรับปรุงข้อมูลนี้ให้เป็นปัจจุบันอยู่เสมอ<br>
                            หากคุณต้องการรับข้อมูลเพิ่มเติม คุณสามารถติดต่อเคาน์เตอร์จัดการของเรา
                            </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "ตลาด",
            "การเทรดหยุดในเวลา (GMT)",
            "การเทรดกลับมาดำเนินต่อในเวลา (GMT)",
          ],
          content_after: `<p class="mt-4">ไม่แน่ใจว่าตลาดมีตราสารที่คุณกำลังมองหาอยู่หรือไม่? คลิก<span class="tclink" target-tab="tc-view-6">ที่นี่</spana>เพื่อดูรายการตราสารทั้งหมดตามรายตลาด</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "คำสั่งและการดำเนินการ",
          content_before: ` <p><b>ประเภทคำสั่ง</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>คำสั่งซื้อขายทันที (Market Order)</th>
                   <th></th>
                </tr>
                <tr>
                   <td>เปิดการซื้อขาย</td>
                   <td>คำสั่งเพื่อเปิดสถานะ ณ อัตราตลาดที่มีในปัจจุบัน</td>
                </tr>
                <tr>
                   <td>ปิดการซื้อขาย</td>
                   <td>คำสั่งเพื่อปิดสถานะ ณ อัตราตลาดที่มีในปัจจุบัน</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>คำสั่งซื้อขายตามราคาที่กำหนด (Limit Order)</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Stop Loss</td>
                   <td>คำสั่งหยุดการขาดทุน หรือ Stop Loss คือคำสั่งเพื่อเปิดหรือปิดการซื้อขายที่อัตราที่ต่ำกว่าอัตราตลาดในปัจจุบัน</td>
                </tr>
                <tr>
                   <td>Take Profit</td>
                   <td>คำสั่งล็อกผลกำไร หรือ Take Profit คือคำสั่งเพื่อเปิดหรือปิดการซื้อขายที่อัตราที่สูงกว่าอัตราตลาดในปัจจุบัน</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>คำสั่งซื้อขายทันที</b><br>คำสั่งซื้อขายทันที หรือ Market Order (คำขอซื้อขาย เช่น เปิดการซื้อขาย ปิดการซื้อขาย) ดำเนินการที่ราคาที่มีผลบนแพลตฟอร์มการเทรดของบริษัท (ฝั่งลูกค้า) ในเวลาเดียวกับที่ดำเนินการตามคำสั่ง โดยราคาดังกล่าวต้องอยู่ภายในระดับการทนยอมรับที่กำหนดไว้ก่อนจากราคาอ้างอิงที่อัปเดตในเซิร์ฟเวอร์ของบริษัท โดยไม่ต้องคำนึงถึงว่าราคาอ้างอิงนั้นสูงกว่าหรือต่ำกว่าราคาที่อัปเดตในแพลตฟอร์มการเทรดหรือไม่ (สิ่งที่คุณเห็นคือสิ่งที่คุณจะได้ หรือ What You See Is What You Get (WYSIWYG)) ในกรณีที่ราคาที่อัปเดตในแพลตฟอร์มการเทรด (ฝั่งลูกค้า) สูงกว่าระดับการทนยอมรับข้างต้น เช่น เนื่องจากการเคลื่อนไหวในราคาของสินทรัพย์อ้างอิงระหว่างเวลาที่ลูกค้าส่งคำสั่งกับเวลาที่เราได้รับและดำเนินการตามคำสั่ง ความผันผวนที่สูงในตลาด และเวลาแฝงในการสื่อสาร จะมีการดำเนินการตามคำสั่งที่ราคาที่อัปเดตในเซิร์ฟเวอร์ของบริษัท ซึ่งจะแตกต่างจากราคาที่อัปเดตในแพลตฟอร์มการเทรด (ราคาตลาด) ตามความสมมาตร ในกรณีที่มีความแตกต่างเป็นอย่างมากระหว่างราคาที่อัปเดตในแพลตฟอร์มการเทรด (ฝั่งลูกค้า) กับราคาที่อัปเดตในเซิร์ฟเวอร์ของบริษัท คำสั่งนั้นจะถูกปฏิเสธ
          </p>
          <p>
             <b>คำสั่งซื้อขายตามราคาที่กำหนด</b><br>คำสั่งซื้อขายตามราคาที่กำหนด หรือ Limit Order (คำสั่งซื้อขายในอนาคต) ดำเนินการที่ราคาตลาดที่อัปเดตบนเซิร์ฟเวอร์ของบริษัท ซึ่งอาจแตกต่างจากราคาที่ระบุในคำสั่ง (การคลาดเคลื่อนของราคา หรือ “Slippage”) Slippage อาจเกิดขึ้นในกรณีที่ในเซิร์ฟเวอร์ไม่มีราคาที่ระบุในคำสั่ง ตัวอย่างเช่น เนื่องจากความผันผวนที่สูง และช่องว่างของราคาตลาด ในกรณีดังกล่าว จะดำเนินการตามคำสั่งที่ราคาแรกที่มี โดยไม่คำนึงถึงทิศทางของ Slippage ไม่ว่าทิศทางนั้นจะให้กำไรกับลูกค้าหรือไม่ก็ตาม ในลักษณะที่สมมาตรและโปร่งใส (Slippage แบบสมมาตร)<br><br>ตราสารที่ไม่มีการซื้อขายใน 24 ชั่วโมง (เช่น หุ้น ดัชนี และ CFDs ของ ETF) อาจพบช่องว่างของตลาดในแต่ละวัน ดังนั้นจึงมีความอ่อนไหวต่อการเลื่อนหลุดมากกว่า สิ่งสำคัญที่ควรทราบคือ Slippage ไม่ส่งผลต่อการป้องกันยอดคงเหลือติดลบ ดังนั้นลูกค้าจะไม่สูญเสียมากกว่าจำนวนเงินที่ลงทุน (รวมถึงผลกำไรใดๆ หากได้รับ) แม้ว่าจะมีการคลาดเคลื่อนเกิดขึ้นก็ตาม
          </p>
          <p>
             <b>ความล่าช้าในการดำเนินการ</b><br>ความล่าช้าในการดำเนินการอาจเกิดขึ้นด้วยเหตุผลหลายประการ เช่น ปัญหาทางเทคนิคกับอินเทอร์เน็ตของลูกค้า การเชื่อมต่อการสื่อสารกับเซิร์ฟเวอร์ของ iFOREX แบบเคลื่อนที่หรืออื่น ๆ ซึ่งอาจส่งผลให้เกิดคำสั่งที่รอดำเนินการ หรือ “Hanging Order” บางครั้ง การรบกวนในเส้นทางการเชื่อมต่อสามารถรบกวนสัญญาณและปิดทางแพลตฟอร์ม ก่อให้เกิดความล่าช้าในการรับ-ส่งข้อมูลระหว่างแพลตฟอร์มของเทรดเดอร์และเซิร์ฟเวอร์ของ iFOREX&nbsp;
          </p>
          <p>
             <b>คำสั่งที่รอดำเนินการ</b><br>ในระหว่างช่วงเวลาที่มีปริมาณการซื้อขายสูงหรือมีเวลาแฝงในการสื่อสาร อาจมีคำสั่งที่รอดำเนินการ หรือ Hanging Order เกิดขึ้น ซึ่งหมายความว่ามีการส่ง Limit Order แล้ว แต่ต้องใช้เวลาสักครู่กว่าที่คำสั่งนั้นจะได้รับการยืนยัน/ประมวลผล ในระหว่างช่วงเวลาที่มีปริมาณการซื้อขายสูงหรือมีเวลาแฝงในการสื่อสารมีความเป็นไปได้ที่จะเกิดคิว Limit Order ขึ้น ในบางครั้ง การเพิ่มขึ้นของคำสั่งที่ได้รับอาจก่อให้เกิดสภาวะที่การยืนยัน/ประมวลผล Limit Order บางรายการมีความล่าช้า ในบางกรณี จริง ๆ แล้วอาจมีการดำเนินการสถานะนั้นแล้ว และความล่าช้านั้นเป็นเพียงแค่การแสดงผลที่ฝั่งของลูกค้าเนื่องจากปริมาณข้อมูลที่วิ่งในอินเทอร์เน็ต<br><br>โปรดทราบว่าการป้อนคำสั่งใด ๆ ก็ตามเพียงครั้งเดียวก็เพียงพอแล้ว การป้อนคำสั่งเดียวกันหลายครั้งอาจทำให้คอมพิวเตอร์ของคุณช้าลงหรือถูกล็อก หรืออาจเปิดสถานะที่ไม่ต้องการโดยไม่ได้ตั้งใจได้
          </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "การป้องกันยอดคงเหลือเป็นลบ",
          content_before: `<p class="">
                            นโยบายการป้องกันยอดคงเหลือเป็นลบ (Negative Balance Protection) ของ iFOREX รับประกันว่าการขาดทุนของลูกค้าจะจำกัดแค่เงินทุนที่ลงทุนในบัญชีของลูกค้า ตามนโยบายนี้ ลูกค้าจะไม่ต้องเผชิญกับยอดเงินเป็นลบเนื่องจากการขาดทุนในการเทรดเมื่อเทรดกับ iFOREX และโอกาสการขาดทุนของลูกค้าจะจำกัดแค่เงินทุนที่ฝากในบัญชีของลูกค้าและเงินทุนที่ลูกค้าได้รับ ถ้ามี
                            </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "bonus_terms_and_conditions",
          id:'btc',
          title: "ข้อกำหนดและเงื่อนไขเกี่ยวกับโบนัส",
          content_before: `
          <p><b>บทนำ</b><br>ข้อกำหนดและเงื่อนไขของโบนัสเหล่านี้เกี่ยวข้องกับโบนัสการซื้อขาย รวมทั้งโบนัสต้อนรับ โบนัสคืนเงิน และโบนัสบัญชีทดลองที่เสนอโดยบริษัท (ต่อไปนี้จะเรียกว่า 'โบนัส') ตามรายละเอียดด้านล่าง และถือเป็นส่วนสำคัญของ ข้อกำหนดและเงื่อนไขของบริษัท การตีความข้อกำหนดทั้งหมดที่รวมอยู่ในที่นี้จะถูกตีความในข้อกำหนดและเงื่อนไขของบริษัท ซึ่งมีอยู่ในเว็บไซต์ของบริษัทที่ <a href="/">www.iforex.co.th</a>.</p>
          <p>
             <b>เงื่อนไขการมีคุณสมบัติ</b><br>โบนัสมีให้สำหรับลูกค้าของบริษัท ที่มีคุณสมบัติตรงตามเกณฑ์กำหนด คุณสมบัติของข้อเสนอที่เกี่ยวข้องผ่านขั้นตอนการลงทะเบียนที่จำเป็นทั้งหมดตามข้อกำหนดของบริษัท ซึ่งสามารถแก้ไขเพิ่มเติมเป็นครั้งคราวตามดุลยพินิจของบริษัท แต่เพียงผู้เดียวและได้รับการอนุมัติจาก บริษัท ในฐานะลูกค้าที่มีความเหมาะสม ('<b>ลูกค้าที่เหมาะสม</b>')
             <br><br>
             บริษัทเสนอที่จะมอบโบนัสใด ๆ ให้แก่ลูกค้ารายใด และ/หรือประเทศ/ภูมิภาคใด ตามดุลยพินิจของตนอย่างไม่มีข้อจำกัดและตามที่ตนเห็นสมควร
             <br><br>
             บริษัทสงวนสิทธิ์ตามดุลยพินิจของตนแต่เพียงผู้เดียวที่จะปฏิเสธการลงทะเบียนของผู้ใช้รายใดก็ตาม ซึ่งรวมถึงลูกค้าที่มีสิทธิ์ ในโบนัสนั้น และ/หรือยกเลิกข้อเสนอของโบนัสใด ๆ ตามดุลยพินิจของตนอย่างไม่มีข้อจำกัด<br><br>ผู้ที่อาศัยในเขตอำนาจที่ต้องจำกัด ซึ่งรวมถึงผู้อยู่อาศัยในสหรัฐอเมริกา จะไม่มีสิทธิ์ได้รับโบนัสการเทรด
          </p>
          <p><b>โบนัสการเทรด</b><br>ภายใต้ข้อกำหนดทั่วไปในที่นี้ โบนัสการซื้อขายจะมอบให้กับลูกค้าที่มีสิทธิ์เป็นเปอร์เซ็นต์ของจำนวนเงินที่ฝากในบัญชีซื้อขายของพวกเขา และ/หรืออย่างอื่นตามที่บริษัทอาจเห็นสมควรตามดุลยพินิจของบริษัทแต่เพียงผู้เดียว
             <br><br>
             โบนัสการซื้อขายถูกกำหนดเพื่อวัตถุประสงค์ในการซื้อขายมาร์จิ้นเท่านั้น ดังนั้นจึงสามารถใช้เป็นมาร์จิ้นพิเศษได้เท่านั้น (เช่น ลูกค้าจะไม่สามารถถอนโบนัสที่ได้รับ).
             <br><br>
             โบนัสการเทรดจะมอบให้กับลูกค้าที่มีสิทธิ์เป็นราย ๆ ไป
             <br><br>
             โบนัสต้อนรับ - เป็นโบนัสการซื้อขายสำหรับผู้ฝากเงินครั้งแรก
          </p>
          ในกรณีที่มีการให้โบนัสการเทรดตามจำนวนเงินที่ฝากเข้าในบัญชี เงื่อนไขดังต่อไปนี้จะบังคับใช้
                      <br>
                      <ol>
                      <li class="mb-0 mt-1">ในกรณีที่ถอนกยอดคงเหลือในเวลาปัจจุบันทั้งหมด - โบนัสการเทรดทั้งหมดจะถูกนำออก</li>
                      <li>ในกรณีที่ถอนยอดคงเหลือในเวลาปัจจุบันเป็นบางส่วน - ยอดโบนัสการเทรดจะปรับเป็น20% ของยอดคงเหลือในเวลาปัจจุบันซึ่งจะยังคงเหลืออยู่ในบัญชีหลังจากการถอนเงิน, หรือตามแต่บริษัทจะพิจารณา, โดยดุลยพินิจของบริษัทแต่เพียงผู้เดียว, เป็นครั้งคราวไป</li>
                      </ol>
          <u style="font-style:italic">ตัวอย่าง</u><br><br>
          ลูกค้าที่มีสิทธิ์ที่ตกลงกับบริษัทจะได้รับโบนัส 30% ในการฝากเงิน $1,000 ลูกค้าที่มีสิทธิ์จะได้รับมาร์จิ้นเพิ่มจำนวน $300 (นั่นคือ 30% ของยอดการฝากเงิน) เป็นโบนัสการเทรด<br><br>โบนัสนี้จะปรากฏบนบัญชีของลูกค้าดังต่อไปนี้:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>ยอดคงเหลือ</th>
                      <th>ยอดคงเหลือในเวลาปัจจุบัน</th>
                      <th>มาร์จิ้นที่มี</th>
                      <th>โบนัสการเทรด</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,300</td>
                      <td>$300</td>
                   </tr>
                </tbody>
             </table>
          </div>
          โบนัสการเทรดจะไม่สามารถถอนออกมาได้ไม่ว่าในเวลาใดก็ตาม ลูกค้าที่มีสิทธิ์อาจถอนผลกำไรใด ๆ ที่ได้จากการใช้โบนัสการเทรด โดยอยู่ภายใต้นโยบายการถอนเงินของบริษัทและกฎหมายที่เกี่ยวข้อง จะสามารถดูผลกำไรที่ได้มาจากโบนัสการเทรดและถอนออกมาได้ใต้ส่วน “ยอดคงเหลือ” ของบัญชีลูกค้า
          <br><br>
          <u style="font-style:italic">ตัวอย่าง</u><br><br>
          ลูกค้าที่มีสิทธิ์ที่ตกลงกับบริษัทจะได้รับโบนัส 30% ในการฝากเงิน $1,000 ลูกค้ามียอดคงเหลือในเวลาปัจจุบันและยอดคงเหลือในบัญชีของตนดังแสดงด้านล่าง
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>ยอดคงเหลือ</th>
                      <th>ยอดคงเหลือในเวลาปัจจุบัน</th>
                      <th>มาร์จิ้นที่มี</th>
                      <th>โบนัสการเทรด</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,300</td>
                      <td>$300</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">สถานการณ์ ก</u><br><br>
          ลูกค้าขอถอนเงินฝากของตนเต็มจำนวน ($1,000) โบนัสการเทรดจะถูกนำออกทั้งหมด<br><br>ในบัญชีของลูกค้าจะแสดงดังนี้:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>ยอดคงเหลือ</th>
                      <th>ยอดคงเหลือในเวลาปัจจุบัน</th>
                      <th>มาร์จิ้นที่มี</th>
                      <th>โบนัสการเทรด</th>
                   </tr>
                   <tr>
                      <td>$0</td>
                      <td>$0</td>
                      <td>$0</td>
                      <td>$0</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">สถานการณ์ ข</u><br><br>
          ลูกค้าขอถอนเงินจำนวน $800 ดังนั้น ยอดคงเหลือในเวลาปัจจุบันของลูกค้าจึงลดลงเหลือ $200 และโบนัสการเทรดในกรณีนี้ถูกจำกัดที่ 20% ของยอดคงเหลือในเวลาปัจจุบัน นั่นคือ $40
          <br><br>ในบัญชีของลูกค้าจะแสดงดังนี้:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>ยอดคงเหลือ</th>
                      <th>ยอดคงเหลือในเวลาปัจจุบัน</th>
                      <th>มาร์จิ้นที่มี</th>
                      <th>โบนัสการเทรด</th>
                   </tr>
                   <tr>
                      <td>$200</td>
                      <td>$200</td>
                      <td>$240</td>
                      <td>$40</td>
                   </tr>
                </tbody>
             </table>
          </div>
          &nbsp;โบนัสการเทรดทั้งหมดจะถูกยกเลิกหากไม่มีการเคลื่อนไหวในบัญชีติดต่อกัน 7 สัปดาห์
          <br><br>
          <p><b>เงินคืน</b><br>
             โปรแกรมเงินคืนให้เครดิตเงินสดกับบัญชีของลูกค้าที่มีสิทธิ์เป็นรายสัปดาห์ โดยเป็นไปตามและขึ้นอยู่กับปริมาณการเทรดที่ทำได้ในสัปดาห์นั้น ๆ สูงสุดเป็นจำนวนที่กำหนดตามที่บริษัทได้ระบุไว้ล่วงหน้า (“โบนัสรอดำเนินการ (Pending Bonus)”)<br><br>โบนัสรอดำเนินการอาจได้มาจากการฝากเงินเป็นจำนวนหนึ่ง ๆ หรือหลายครั้ง เป็นร้อยละของมูลค่าของการฝากเงิน หรือตามที่บริษัทระบุตามดุลยพินิจของบริษัทแต่เพียงผู้เดียว
          </p>
          <u style="font-style:italic">ตัวอย่าง</u><br><br>
          ลูกค้าที่มีสิทธิ์ที่ฝากเงิน $1,000 มีสิทธิ์ได้รับเงินคืนสูงสุด 40% ของมูลค่าเงินฝากของตนสำหรับปริมาณการเทรดที่ $20,000,000 ลูกค้ารายดังกล่าวจะได้รับ $400 เป็นโบนัสรอดำเนินการ<br><br>โบนัสรอดำเนินการนี้จะปรากฏบนบัญชีของลูกค้าดังต่อไปนี้:
          <div class="table-wrapper">
             <table class="table2 mt-3 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>ยอดคงเหลือ</th>
                      <th>ยอดคงเหลือในเวลาปัจจุบัน</th>
                      <th>มาร์จิ้นที่มี</th>
                      <th>โบนัสรอดำเนินการ</th>
                      <th>ปริมาณที่เทรดแล้ว</th>
                      <th>ปริมาณที่จำเป็นต้องเทรด</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$400</td>
                      <td>$0</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          ในแต่ละสัปดาห์ เงินคืนที่เกิดขึ้นแล้ว ซึ่งคำนวณตามปริมาณการเทรดรายสัปดาห์ของลูกค้า จะถูกหักลบจากยอดเงินคืนทั้งหมด (โบนัสรอดำเนินการ) และยอดเงินคืนที่เกิดขึ้นแล้วดังกล่าวจะมีการเครดิตเข้าบัญชีของลูกค้าตามอัตราส่วนระหว่างปริมาณการซื้อขายจริงรายสัปดาห์ของลูกค้า (ใน USD) และปริมาณที่ต้องเทรด ดังที่แสดงในแพลตฟอร์มการเทรด โปรดทราบว่าลูกค้ามีสิทธิ์ได้รับเพียงเงินคืนที่เกิดขึ้นแล้วเท่านั้น และจะได้รับโบนัสรอดำเนินการหลังจากที่ลูกค้าเทรดได้ตามปริมาณที่กำหนดแล้วเท่านั้น จำนวนเงินคืน (“เงินคืนที่เกิดขึ้นแล้ว” (Realized CashBack)) จะจำกัดที่โบนัสรอดำเนินการที่ได้จัดสรรให้กับลูกค้า<br><br>ปริมาณการเทรดคำนวณตามหลัก “เงินเข้าและเงินออก” ซึ่งหมายความว่าการเปิดสถานะ $1 ล้าน (หรือจำนวนเงินที่เทียบเท่าในสกุลเงินอื่น) และการปิดสถานะเดียวกันจะนำไปนับเป็นยอดเงินทั้งหมด $2 ล้าน (หรือจำนวนเงินที่เทียบเท่าในสกุลเงินอื่น) ในปริมาณที่จำเป็นต้องเทรดของลูกค้า
          <br><br>
          <u style="font-style:italic">ตัวอย่าง</u><br><br>
          <u style="font-style:italic">สถานการณ์ ก</u><br><br>
          ลูกค้าที่มีสิทธิ์ในตัวอย่างก่อนหน้าได้รับข้อเสนอเงินคืน (เงินคืนที่เกิดขึ้นแล้ว) $100 สำหรับแต่ละ $5,000,000 ที่เทรด หลังผ่านไป 1 สัปดาห์ ลูกค้ามีปริมาณการเทรดถึง $5,000,000 ดังนั้นยอดเงินคืนที่เกิดขึ้นแล้ว $100 จึงถูกย้ายจากโบนัสรอดำเนินการไปยังยอดคงเหลือในเวลาปัจจุบัน<br><br>ในบัญชีของลูกค้าจะแสดงดังนี้:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>ยอดคงเหลือ</th>
                      <th>ยอดคงเหลือในเวลาปัจจุบัน</th>
                      <th>มาร์จิ้นที่มี</th>
                      <th>โบนัสรอดำเนินการ</th>
                      <th>ปริมาณที่เทรดแล้ว</th>
                      <th>ปริมาณที่จำเป็นต้องเทรด</th>
                   </tr>
                   <tr>
                      <td>$1,100</td>
                      <td>$1,100</td>
                      <td>$1,100</td>
                      <td>$300</td>
                      <td>$5,000,000</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">สถานการณ์ ข</u><br><br>
          หลังผ่านไป 2 สัปดาห์นับจากที่ฝากเงิน ลูกค้ามีปริมาณการเทรดถึง $5,000,000 และได้ผลกำไร $300 ดังนั้นยอดเงินคืนที่เกิดขึ้นแล้วอีก $100 จึงถูกย้ายจากโบนัสรอดำเนินการไปยังยอดคงเหลือในเวลาปัจจุบัน<br><br>ในบัญชีของลูกค้าจะแสดงดังนี้:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>ยอดคงเหลือ</th>
                      <th>ยอดคงเหลือในเวลาปัจจุบัน</th>
                      <th>มาร์จิ้นที่มี</th>
                      <th>โบนัสรอดำเนินการ</th>
                      <th>ปริมาณที่เทรดแล้ว</th>
                      <th>ปริมาณที่จำเป็นต้องเทรด</th>
                   </tr>
                   <tr>
                      <td>$1,500</td>
                      <td>$1,500</td>
                      <td>$1,500</td>
                      <td>$200</td>
                      <td>$10,000,000</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          หลังจากที่มีการเครดิตเงินคืนที่เกิดขึ้นแล้วไปยังยอดคงเหลือในเวลาปัจจุบัน เงินคืนที่เกิดขึ้นแล้วจะสามารถนำมาใช้เทรดหรือลูกค้าสามารถถอนออกมาได้ทุกเมื่อ ลูกค้าที่มีสิทธิ์ยังอาจถอนผลกำไรใด ๆ ที่ได้จากการนำยอดเงินคืนที่เกิดขึ้นแล้วไปลงทุนได้เช่นกัน<br><br>โปรโมชันเงินคืนเป็นโปรโมชันที่มีระยะเวลาจำกัด และลูกค้าได้รับเงินคืนที่เกิดขึ้นแล้วภายในช่วง 3 เดือนแรกนับจากวันที่ตนได้รับโบนัสรอดำเนินการ ลูกค้ามีสิทธิ์ได้รับเงินคืนเพิ่มเติมเมื่อลูกค้าฝากเงินเพิ่ม
          <br><br>
          <u style="font-style:italic">ตัวอย่าง</u><br><br>
          ลูกค้าที่มีสิทธิ์ในตัวอย่างก่อนหน้าตัดสินใจที่จะถอนเงินผลกำไร $300 และยอดเงินคืนที่เกิดขึ้นแล้ว $200 ที่ได้รับ ดังนั้น เขาจึงขอถอนเงินเป็นจำนวนทั้งหมด $500 โบนัสเงินคืนที่เหลือจำนวน $200 จะยังคงอยู่ในรูปโบนัสรอดำเนินการในบัญชีของเขา ดังนั้น ลูกค้าจะยังสามารถเทรดต่อไปด้วยเงินจำนวน $1,000 และมีเวลาเหลืออีกสองเดือนครึ่งที่จะเปลี่ยนโบนัสรอดำเนินการให้เป็นเงินคืนที่เกิดขึ้นแล้ว<br><br>ในบัญชีของลูกค้าจะแสดงดังนี้:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>ยอดคงเหลือ</th>
                      <th>ยอดคงเหลือในเวลาปัจจุบัน</th>
                      <th>มาร์จิ้นที่มี</th>
                      <th>โบนัสรอดำเนินการ</th>
                      <th>ปริมาณที่เทรดแล้ว</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$200</td>
                      <td>$10,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          เงินคืนทั้งหมดมอบให้ในสกุลเงินของบัญชี&nbsp;
          <br><br>
          <p>
             <b>บัญชีทดลอง</b><br>
             ผู้ใช้อาจได้รับบัญชีทดลองที่มีโบนัสซื้อขาย (ตามที่อธิบายไว้ข้างต้น) มูลค่า 25 เหรียญสหรัฐ ซึ่งสามารถใช้ในการซื้อขายได้ โดยขึ้นอยู่กับเงื่อนไขการซื้อขายของบริษัท
             <br><br>
             บัญชีทดลองจะหมดอายุและธุรกรรมที่รอดำเนินการทั้งหมดในบัญชีทดลองจะถูกยกเลิกภายใน 3 วันนับจากวันที่มีการทำธุรกรรมครั้งแรกในบัญชีทดลอง ("ระยะเวลาทดลองใช้") จำนวนเงินใดๆ ที่เกินกว่า 25$ ดอลลาร์สหรัฐ (“กำไร”) อาจใช้เป็นมาร์จิ้นสำหรับบัญชีซื้อขายของผู้ใช้กับบริษัท และ/หรือสำหรับการซื้อขายผลิตภัณฑ์ที่ไม่มีเลเวอเรจ ขึ้นอยู่กับการสิ้นสุดขั้นตอนการลงทะเบียนของบริษัทของผู้ใช้ที่ประสบความสำเร็จและขั้นต่ำ การฝากเงิน 100 เหรียญสหรัฐฯ หรือสามารถถอนเข้าบัญชีธนาคารโดยใช้ชื่อผู้ใช้ได้ โปรดทราบว่า (i) การถอนขึ้นอยู่กับขั้นตอนการถอนของบริษัทและอาจมีค่าธรรมเนียมการโอน และ (ii) กำไรใดๆ ที่ไม่ได้ถอนออกหรือโอนไปยังบัญชีซื้อขายและใช้เป็นมาร์จิ้นเพื่อการค้าและ/หรือ การซื้อขายผลิตภัณฑ์ที่ไม่มีเลเวอเรจไม่เกิน 14 วันนับจากวันที่เปิดธุรกรรมครั้งแรกในบัญชีทดลองจะถูกเพิกถอน
             <br><br>
             โบนัสมีให้สำหรับลูกค้าที่ลงทะเบียนกับแพลตฟอร์มของบริษัทเป็นครั้งแรกและมีคุณสมบัติตามเกณฑ์คุณสมบัติที่อธิบายข้างต้นเท่านั้น มีโบนัสให้หนึ่งครั้งต่อที่อยู่บ้าน/ที่อยู่ IP
          </p>
          <p>
             <b>ข้อกำหนดทั่วไป</b><br>
             ข้อบ่งชี้หรือข้อสงสัยใด ๆ เกี่ยวกับวิธีการหรือการกระทำการเทรดที่ไม่ถูกต้องตามกฎหมาย ไม่เป็นธรรม และ/หรือเป็นการเทรดในทาง
             ที่ผิดตามดุลยพินิจของบริษัท (ซึ่งรวมถึงแต่ไม่จำกัดเพียง รูปแบบกิจกรรมการเทรดที่บ่งชี้ว่ามีจุดมุ่งหมายที่จะได้รับประโยชน์ทางการเงินจาก
             โบนัสการเทรดโดยไม่รับความเสี่ยงของตลาด และ/หรือโดยการเปิด ปฏิบัติงาน หรือจัดการบัญชีมากกว่าหนึ่งบัญชีต่อรายลูกค้า) รวมทั้ง
             ข้อบ่งชี้หรือข้อสงสัยใด ๆ ว่ามีการหลอกลวง การชักนำ หรือการละเมิดข้อตกลง นโยบาย และเงื่อนไขของบริษัทในเรื่องเกี่ยวกับแผนการให้โบนัส จะทำให้โบนัสทั้งหมดที่ได้เครดิตให้กับบัญชีและบัญชีใด ๆ ที่เกี่ยวข้องก่อนหน้านี้เป็นโมฆะ ภายใต้สถานการณ์ดังกล่าว บริษัทมีสิทธิ์ที่จะยกเลิก
             และทำให้การทำรายการทั้งหมดที่ดำเนินการ และ/หรือผลกำไรหรือการขาดทุนที่สะสมในการทำรายการทั้งหมดดังกล่าวเป็นโมฆะ และบล็อก
             บัญชีที่เกี่ยวข้องทั้งหมดตามดุลยพินิจของบริษัทแต่เพียงผู้เดียว โดยไม่เป็นการลิดรอนสิทธิ์ของบริษัทภายใต้ข้อตกลงของบริษัทกับลูกค้าและ
             กฎหมายที่เกี่ยวข้อง และบริษัทจะไม่รับผิดชอบต่อผลที่เกิดขึ้นจากการกระทำการใดๆดังกล่าว
             <br><br>
             บริษัทขอสงวนสิทธิ์ ตามดุลยพินิจของบริษัทแต่เพียงผู้เดียวที่เห็นสมควรในการเปลี่ยนแปลง แก้ไข ระงับ ยกเลิกหรือยุติโบนัสใด ๆ ที่กล่าวถึงข้างต้น หรือแง่มุมใด ๆ ของข้อเสนอที่กล่าวถึงข้างต้น เมื่อใดก็ได้
          </p>`,
          data_id: "",
          content_after: "",
        },
        {
         //id: "margin_information",
         id:'tc-view-24',
         title: "Margin Information",
         content_before: `
                     <p>
                     The window displayed below provides detailed information related to the margin of an account:
                     <div class="table-wrapper">
                        <table class="table3 mt-4 mb-4">
                           <tbody>
                           <tr>
                                 <td>Equity</td>
                                 <td style="">4995</td>
                              </tr>
                              <tr>
                                 <td>Used Margin</td>
                                 <td style="">2,500</td>
                              </tr>
                              <tr>
                                 <td>Available Margin</td>
                                 <td style="">2,495</td>
                              </tr>
                              <tr>
                                 <td>Margin Utilization</td>
                                 <td style="color:green">+50.05%</td>
                              </tr>
                              <tr>
                                 <td>Maintenance Margin</td>
                                 <td style="">500</td>
                              </tr>
                              <tr>
                                 <td>Net Exposure</td>
                                 <td>250000</td>
                              </tr>
                              <tr>
                                 <td>Exposure Coverage</td>
                                 <td>+1.998%</td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                     <ul class="list-style-disc-small mb-3">
                        <li><b>Used Margin</b> shows the amount of Equity in an account that is currently being used as Margin for your Open Deals. In the case where Used Margin is equal to or larger than the Equity, this indicates that the account's leverage is Maximized. During and around trading breaks, the Required Margin of some instruments (as detailed in the ‘Product Details table’) increases - and this affects the Available Margin, which might be dramatically reduced during the weekend as a result.<br>Used Margin = Net Exposure in an Instrument x The Required Margin for that Instrument</li>
                       <li><b>Margin Available</b> shows the amount of equity in an account that is not currently being used and is available for further increase of net exposure. In the case where Margin Available is zero, this indicates maximum leverage usage in the account.<br>Margin Available = Equity – Used Margin</li>
                        <li><b>Margin Utilization</b> shows the percentage of Equity that is being used as Margin for the currently Open Deals of the account. 100% Margin Utilization and above, indicates maximum leverage usage in the account.<br>Margin Utilization % = (Used Margin/Equity) x 100</li>
                        <li><b>Maintenance Margin</b> reflects 20% of the Used Margin required to maintain Open Deals in the account. When the Equity of an account reaches or falls below the defined Maintenance Margin, a Margin Close-out Protection (as defined hereunder) will automatically be activated.<br>Maintenance Margin = Used Margin X a percentage (%) defined in the Trading Platform.
                        <br>
                        iFOREX reserves the right, but is not obliged,  to set and/or change Maintenance Margin, at its sole discretion.</li>
                        <li><b>Exposure Coverage</b> shows what percentage of the Net Exposure of an account is held in equity as collateral.<br>Exposure Coverage = Equity/Net Exposure</li>
                     </ul>
                     <b>Margin Close-out Protection</b><br>Should a client’s Equity reaches or falls below the Maintenance Margin level, iFOREX will auto close the deal that consumes the largest amount of Used Margin, in order to achieve the lowest possible Maintenance Margin, affecting only Open Deals on instruments available during their respective trading hours. Should there be no Open Deals at the time, the first instrument to receive a quote will be auto closed first. Where there are multiple deals (more than one) that equally consume the largest amount of Used Margin, the Company will auto close the deal that was opened first. In the event that the lowest possible Maintenance Margin cannot be achieved by the auto closing of a single deal, iFOREX will auto close all Open Deals under a specific instrument. 
                       <br>iFOREX allows clients the full use of unrealized profits from their Open Deals, in order to support their losing deals. 
                     <br><br>
                     <b><u><u>Margin Close-out Protection Examples</u></u></b><br>
                     For the purpose of the examples hereof, the Maintenance Margin = Used Margin x 20%
                   <br><br>
                     <b>Example I: Multiple Deals (without a Trading Bonus)</b><br>
                     This example involves a client with multiple open deals. The account's Equity drops to the Maintenance Margin level. <br><br>
                     <ul class="list-style-disc-small mb-3">
                        <li>Open Deals:</li>
                        <ul class="list-style-disc-small empty-disc ml-4">
                           <li>1 USD/JPY deal: Bought $200,000 at a rate of 150.22 (Used Margin = 0.25% x $200,000 = $500)</li>
                           <li>1 Gold deal: Bought 100 ounces at a rate of 2,300.00 (Used Margin = 0.5% x 100 x $2,300.00 = $1,150)</li>
                           <li>1 WTI Oil deal: Bought 500 barrels at a rate of 70.00 (Used Margin = 1% x 500 x $70 = $350)</li>
                        </ul>
                        <li>Total Used Margin: $2,000</li>
                        <li>Maintenance Margin Level: $400</li>
                     </ul>
                     
                     <p><b>Process:</b></p>

                     <ol>
                       <li>When the account's Equity drops to or below $400, the system closes the deal using the highest Used Margin (Gold). This reduces the Used Margin to $850, lowering the Maintenance Margin to $170.</li>
                       <li> If Equity drops to or below $170, the system closes the USD/JPY deal, reducing Used Margin to $350 and the Maintenance Margin to $70.</li>
                       <li>Finally, if Equity falls to or below $70, the system closes the last remaining deal (WTI Oil).</li>

                     </ol>
                     <b>Example II: Single Deal (including a Trading Bonus)</b><br>
                     This example involves a client with one open deal, a Trading Bonus, and Equity at or below the Maintenance Margin.<br><br>
                     <ul class="list-style-disc-small mb-3">
                       <li><b>Deposit:</b> $1,000 (with a 100% Trading Bonus)</li>
                       <li><b>Total Equity:</b> $2,000</li>
                       <li><b>Open Deal:</b> Bought $800,000 in USD/JPY</li>
                       <li><b>Used Margin:</b> 0.25% x $800,000 = $2,000</li>
                       <li><b>Maintenance Margin Level:</b> $400</li>
                     </ul>
                     
                     <p><b>Process:</b> When Equity falls to or below -$600, triggering a Total Equity level of $400, the system closes the only open deal.</p>
                     
                     <b>Example III: Multiple Deals (including Trading Bonus)</b><br>

                     A client holds multiple open deals, with a Trading Bonus and Equity at or below the Maintenance Margin.<br><br>

                     <ul class="list-style-disc-small mb-3">
                       <li><b>Deposit:</b> $1,000 (with a 100% Trading Bonus)</li>
                       <li><b>Total Equity:</b> $2,000</li>
                        <li><b>Open Deals:</b></li>
                        <ul class="list-style-disc-small empty-disc ml-4">
                           <li>1 USD/JPY deal: Bought $400,000 at a rate of 150.22 (Used Margin = 0.25% x $400,000 = $1,000)</li>
                           <li>1 WTI Oil deal: Bought 1,000 barrels at a rate of 85.00 (Used Margin = 1% x 1,000 x $85 = $850)</li>
                        </ul>
                        <li><b>Total Used Margin:</b> $1,850</li>
                        <li><b>Maintenance Margin Level:</b> $370</li>
                     </ul>

                     <p><b>Process:</b></p>
                       <ol>
                           <li>When Equity falls to or below -$630, triggering Total Equity of $370, the USD/JPY deal is closed.</li>
                           <li>With the USD/JPY deal closed, Used Margin is now $850 and Maintenance Margin Level is $170 ($850 x 20%).</li>
                           <li>If Equity drops to -$830 (Total Equity = $170), the system closes the WTI Oil deal.</li>
                       </ol>
                     
                     </p>`,
         data_id: "",
         content_after: "",
       },
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "กฎเพิ่มเติมเกี่ยวกับการเทรด",
          content_before: `
              <p>
              <b>สถานะความเสี่ยงสูงสุด</b><br>
              เพื่อเป็นมาตรการระมัดระวังที่มีจุดมุ่งหมายเพื่อการบริหารจัดการความเสี่ยงที่ดีขึ้นและการหลีกเลี่ยงสถานะความเสี่ยงที่มากเกินไปในลูกค้ารายเดียว iFOREX จึงกำหนดขีดกำหนดสถานะความเสี่ยงสุทธิสูงสุดที่ไม่เกิน 15 (สิบห้า) ล้านดอลลาร์สหรัฐฯ ต่อรายลูกค้า นอกจากนี้ iFOREX ยังกำหนดสถานะความเสี่ยงสุทธิสูงสุดสำหรับรายตราสารด้วยเช่นกัน หากต้องการดูสถานะความเสี่ยงสูงสุดต่อรายตราสาร โปรด<span class="tclink" target-tab="tc-view-6" target-section="product_section">คลิกที่นี่</span> iFOREX มีสิทธิตามดุลยพินิจของตนแต่เพียงผู้เดียวที่จะยกเลิกหรือเปลี่ยนแปลงข้อจำกัดดังกล่าวในเวลาใด ๆ ก็ตามโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
              <br><br>
              <b>Hedging</b><br>
              การป้องกันความเสี่ยง หรือ Hedging มีนิยามคือ การเปิดรายการเทรดสองรายการในตราสารหรือสินทรัพย์อ้างอิงเดียวกันในทิศทางที่แตกต่างกัน (ทิศทางหนึ่งคือ “ซื้อ” และอีกทิศทางหนึ่งคือ “ขาย”) ไม่ว่าจะเป็นเวลาเดียวกันหรือไม่และไม่ว่าจะเป็นจำนวนเดียวกันหรือไม่ก็ตาม iFOREX พิจารณาการทำรายการ Hedging เพื่อวัตถุประสงค์ในการคำนวณมาร์จิ้นต่ำสุดตามหลักสะสมหรือตามหลัก “สุทธิ” นอกจากนี้ iFOREX พิจารณาการปิดหนึ่งในการทำรายการที่มีการ Hedging ว่าเป็นการเปิดการทำรายการใหม่ซึ่งมีจำนวนเท่ากับจำนวนของการทำรายการที่เหลือ
              <br><br>
              <b>การสุทธิการทำรายการ</b><br>
              ในกรณีที่มีการซื้อขายมากกว่าหนึ่งรายการที่ต้องปิดพร้อมกันในบัญชี iFOREX จะปิดสถานะที่เปิดอยู่ทั้งหมดหลายรายกันพร้อมกัน หมายเลขการทำรายการที่กำหนดให้กับสถานะที่ปิดแต่ละสถานะได้รับการกำหนดตามกฎเข้าก่อนออกก่อน (FIFO) ซึ่งหมายความว่าเมื่อปิดหลายสถานะ สถานะแรกที่เปิดจะได้รับหมายเลขการทำรายการต่ำสุด และสถานะสุดท้ายที่เปิดจะได้รับหมายเลขการทำรายการสูงสุด
              <br><br>
              <b>การปฏิบัติที่ไม่อนุญาตในการเทรด</b><br>
              iFOREX สนับสนุนการซื้อขายที่เป็นธรรม และไม่อนุญาตให้มีการปฏิบัติที่เป็นการซื้อขายในทางที่ผิด เช่น การเทรดแบบแล็ก การปั่นราคา การปั่นเวลา หรือการปฏิบัติอื่นใดที่ผิดกฎหมายและ/หรือมีการใช้เพื่อให้ลูกค้าได้รับข้อได้เปรียบอย่างไม่เป็นธรรม ตัวอย่างของการปฏิบัติที่ต้องห้ามดังกล่าวรวมถึง แต่ไม่จำกัดเพียง การปฏิบัติใด ๆ ต่อไปนี้:
              <ul class="list-style-disc-small mt-3 mb-2">
                 <li>
                    <b>การเทรดระยะสั้น (Scalping)</b> คือกลยุทธ์การเทรดที่พยายามจะทำกำไรจำนวนมากจากการเปลี่ยนแปลงของราคาเล็กน้อย เทรดเดอร์ที่ใช้กลยุทธ์นี้จะส่งการเทรดเป็นจำนวนใด ๆ ตั้งแต่ 10 รายการถึงหลายร้อยรายการในวันเดียวด้วยมีความเชื่อว่าการเคลื่อนไหวของราคาเล็กน้อยนั้นจับได้ง่ายกว่าการเคลื่อนไหวที่ใหญ่กว่า
                 </li>
                 <li>
                    <b>การดำเนินการอัตโนมัติ</b> (เช่น EA) หรือการเทรดด้วยชุดคำสั่งคอมพิวเตอร์ (algorithmic trading) คือการใช้แพลตฟอร์มอิเล็กทรอนิกส์เพื่อส่งคำสั่งการเทรด โดยมีชุดคำสั่งที่จะดำเนินการตามคำสั่งการเทรดที่ได้กำหนดโปรแกรมไว้ก่อน ซึ่งอาจมีตัวแปรต่าง ๆ ที่รวมถึงกรอบระยะเวลา ราคา หรือจำนวนของคำสั่ง หรือในหลายกรณีจะเริ่มต้นคำสั่งด้วย “โรบอท” โดยไม่มีการแทรกแซงของมนุษย์
                 </li>
                 <li>
                    <b>การเทรดด้วย API</b> คือส่วนต่อประสานโปรแกรมประยุกต์ที่หมายถึงการเทรดทั้งหมดที่ใช้โปรแกรมซอฟต์แวร์เพื่อโต้ตอบกับโปรแกรมอื่น ๆ API ทำหน้าที่เป็นตัวกลางระหว่างเทรดเดอร์และตลาด และถ่ายทอดคำสั่งและเรียกข้อมูลตามต้องการ
                 </li>
                 <li>
                    <b>“หลายบัญชี”</b> หมายถึงสถานการณ์ที่ลูกค้าหนึ่งรายสร้างบัญชีสองบัญชีขึ้นไปเพื่อให้ได้รับผลประโยชน์หลายอย่างที่เกี่ยวข้องกับบัญชีจาก iFOREX อย่างหลอกลวง
                 </li>
              </ul>
              <p>ในกรณีที่บริษัทมีข้อบ่งชี้หรือข้อสงสัยใดๆ ขึ้นอยู่กับดุลยพินิจของบริษัทแต่เพียงผู้เดียว เกี่ยวกับการแสวงหาผลประโยชน์ในรูปแบบใดๆที่ผิดกฎหมาย ไม่ยุติธรรม ไม่ได้รับอนุญาต และ/หรือแนวทางปฏิบัติทางการค้าที่ไม่เหมาะสม ซึ่งใช้เพื่อมอบข้อได้เปรียบที่ไม่เป็นธรรมแก่ลูกค้า และ/หรือการฉ้อโกง การจัดการหรือการฝ่าฝืนข้อตกลง นโยบาย ข้อกำหนดและเงื่อนไขของบริษัท บริษัทจะมีสิทธิ์ตามดุลยพินิจของบริษัทแต่เพียงผู้เดียวและโดยปราศจากการตัดทอนจากสิทธิ์ภายใต้ข้อตกลงกับลูกค้าและกฎหมายที่ใช้บังคับในการลบล้างและยกเลิกธุรกรรมทั้งหมดที่ดำเนินการในบัญชีที่เกี่ยวข้อง รวมถึงกำไรหรือขาดทุนทั้งหมดที่เกิดขึ้นในนั้น จะลบโบนัสใดๆที่มอบให้แก่ลูกค้าและ/หรือบล็อกบัญชี.</p>
              <b>ความผิดพลาดของอัตรา</b><br>
              เทคโนโลยีการเทรดทางออนไลน์ไม่ได้สมบูรณ์แบบ และในบางกรณีที่พบได้น้อยมาก ฟีดเนื้อหาอาจถูกหยุดชะงัก ซึ่งอาจคงอยู่เป็นเวลาชั่วครู่ แต่เมื่อเกิดขึ้นแล้วมักส่งผลกระทบไปที่ราคา แม้ว่าการส่ง “การทำรายการเพื่อทำกำไรจากสองตลาด (arbitrage transaction)” จะเป็นสิ่งที่ชวนให้ทำ โปรดทราบว่าในสถานการณ์ดังกล่าว ราคาจะไม่สะท้อนถึงราคาตลาดที่แท้จริง และการดำเนินการตามคำสั่งของคุณจริง ๆ อาจแตกต่างจากราคาที่แสดงหลาย pip ในกรณีที่มีการดำเนินการเทรดที่ราคาที่ iFOREX ไม่ได้เสนอให้จริง ๆ iFOREX สงวนสิทธิ์ที่จะย้อนกลับการเทรดดังกล่าวเนื่องจากการเทรดเหล่านั้นไม่ถือว่าเป็นการเทรดที่ถูกต้อง โปรดทราบว่าโดยปกติแล้วสถานการณ์เหล่านี้พบได้น้อยมาก และการไม่เทรดในระหว่างช่วงเวลาเหล่านี้จะทำให้เทรดเดอร์สามารถหลีกเลี่ยงความเสี่ยงที่เกี่ยวข้องกับสถานการณ์ข้างต้นได้
              <br><br>
              <b>Vault</b><br>
                  This feature enables clients to exclude funds available in their account without such funds being affected by the account’s trading activity and, subject to a client’s discretion, may be restored at any given time to support the account's trading Margin requirements. The use of Vault will be permitted to clients of the Company, subject to its sole discretion. Where Vault is made available to clients use, the following terms will apply: (i) bonuses granted by the Company cannot be allocated to Vault; (ii) restoration of funds back to client’s account will be made in accordance with the sums as originally were allocated to Vault, but not the entire accumulated sums at once (e.g. if a client allocated $50 and then another $100 to Vault, the client will not be able to restore USD 150 at once, rather the different amounts separately, as originally allocated); (iii) should an account become inactive, all funds available in Vault will be restored by the Company automatically to the Equity of the account and Inactivity Fees will be deducted in accordance with the terms of section 13.3 of the Client Agreement; (iv) the Company reserves the right, as it may see fit, to deny the use of Vault, to change and update its terms of use, and to cancel it.
                  <br><br>
                  <b>Inactivity Fee</b><br>
                  Clients’ accounts in which there have been no trading activity for a period of twelve (12) consecutive months may be charged with a quarterly inactivity fee of US$15 or the account’s entire Equity if the Equity is less than US$15.
                  <br><br>
              <b>ค่าธรรมเนียมการแปลงสกุลเงิน</b><br>
              การซื้อขายตราสารทางการเงินในสกุลเงินอื่นกับสกุลเงินในบัญชีซื้อขายของลูกค้า อาจทำให้ลูกค้าดังกล่าวต้องเสียค่าธรรมเนียมการแปลงสกุลเงิน
              <br><br>
              การฝากเงินหรือการถอนเงินจากบัญชีซื้อขายโดยใช้บัตรเครดิตในสกุลเงินอื่นที่ไม่ใช่สกุลเงินของบัญชีซื้อขายอาจมีค่าธรรมเนียมการแปลงที่เรียกเก็บโดยบริษัทบัตรเครดิตของลูกค้า
              <br><br>
              <b>Unavailability and inaccessibility of trading services from certain Restricted Countries</b><br>
              The trading platform and/or trading services will not be made possible or available from certain Restricted Countries including, without limitations to, the USA. For further information regarding limitations on the use of, or of the accessibility to, Company’s services or website from certain Restricted Countries, including the list of the Restricted Countries, kindly click <a href="/legal/restricted-countries" target="_blank" rel="noopener">here</a>.
              <br><br>
              สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการเทรด โปรดดูที่ <a href="/legal/client-agreement.pdf" target="_blank" rel="noopener">ข้อตกลงของลูกค้า</a>ของเรา
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "ฟอเร็กซ์",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "ค่าธรรมเนียมการถือสถานะข้ามคืน",
          content_before: `
                  <p>
                  เมื่อเทรด CFD ฟอเร็กซ์ที่มีเลเวอเรจกับ iFOREX การซื้อขายที่เปิดอยู่ของคุณต้องมีค่าธรรมเนียมการถือสถานะข้ามคืน (Overnight Financing) เมื่อสิ้นสุดวันซื้อขายแต่ละวัน ค่าธรรมเนียมการถือสถานะข้ามคืนนี้อาจต้องมีการเครดิตหรือเดบิต โดยคำนวณตามอัตราดอกเบี้ยที่เกี่ยวข้องสำหรับสกุลเงินที่ใช้เทรดตราสารอ้างอิง บวกด้วยส่วนเพิ่ม ส่วนเพิ่มสำหรับคู่สกุลเงินเริ่มต้นที่ 0.75% และอาจเพิ่มขึ้น อีกทั้งอาจแตกต่างกันไประหว่างสถานะ Long (ซื้อ) และ Short (ขาย) โปรดดูตารางด้านล่างเพื่อดูระดับค่าธรรมเนียมการถือสถานะข้ามคืนล่าสุด
                  <br><br>
                  หากร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนที่คำนวณได้เป็นบวก นั่นหมายความว่าจะมีการเพิ่มยอดเงินที่เกี่ยวข้อง (เครดิต) เข้าไปในยอดคงเหลือในบัญชีของคุณ ส่วนร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนที่เป็นลบหมายความว่าจะมีการหักยอดเงินที่เกี่ยวข้อง (เดบิต) ออกจากยอดคงเหลือในบัญชีของคุณ
                  <br><br>
                  คุณสามารถดูร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนที่เกี่ยวข้อง ยอดเงิน และเวลาดำเนินการที่เกี่ยวข้องของค่าธรรมเนียมบนทั้งแบบฟอร์ม Deal และ Limit ในแท็บ “ข้อมูลตลาด” หากต้องการคำนวณค่าธรรมเนียมการถือสถานะข้ามคืนที่จะมีการเดบิตหรือเครดิตกับบัญชีของคุณ เพียงนำร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนไปคูณขนาดการซื้อขายของคุณ เวลาดำเนินการของกระบวนการถือสถานะข้ามคืนสำหรับ CFD แต่ละรายการมีรายละเอียดอยู่ใน “เครื่องมือข้อมูลตราสาร” ของแบบฟอร์ม Deal ใต้ “ค่าธรรมเนียมการถือสถานะข้ามคืน (GMT)” ค่าและร้อยละที่คำนวณได้ของค่าธรรมเนียมการถือสถานะข้ามคืนของตราสารหนึ่ง ๆ มีผลเป็นเวลา 1 วัน CFD ที่เทรดสัปดาห์ละ 5 วันจะมีการเครดิตหรือเดบิตด้วยค่าที่แสดงคูณด้วย 3 ในระหว่างวันสุดท้ายของสัปดาห์ซื้อขายของสินทรัพย์อ้างอิงของ CFD เนื่องจากค่านี้ครอบคลุมช่วงเวลาทั้งสุดสัปดาห์ ยอดค่าธรรมเนียมการถือสถานะข้ามคืนจะระบุตามสกุลเงินของ CFD อย่างไรก็ตาม หากสกุลเงินของ CFD ที่ระบุแตกต่างจากสกุลเงินของบัญชี จะมีการแปลงสกุลเงินเป็นสกุลเงินของบัญชี
                  <br><br>
                  <u><b><u>สูตร</u></b></u><br><br>
                  การคำนวณร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):
                  <br>
  
                    <div class="formula formula_f1">
                        <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">อัตราดอกเบี้ยกลาง 3 เดือนของอีกสกุลเงิน- อัตราดอกเบี้ยกลาง 3 เดือนของสกุลเงินพื้นฐาน+ส่วนเพิ่มสถานะ Long</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    การคำนวณร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):
                      <br>
                      <br>
                      <div class="formula formula_f2 mb-4">
                        <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">อัตราดอกเบี้ยกลาง 3 เดือนของอีกสกุลเงิน-อัตราดอกเบี้ยกลาง 3 เดือนของสกุลเงินพื้นฐาน-ส่วนเพิ่มสถานะ Short</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                  
                      หากต้องการคำนวณยอดค่าธรรมเนียมการถือสถานะข้ามคืน เพียงคูณยอดการซื้อขายด้วยด้วยร้อยละ:<br><br>ยอดค่าธรรมเนียมการถือสถานะข้ามคืน = ยอดการซื้อขาย × ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน
                    <br><br><br>
                    <u><b><u>ตัวอย่าง</u></b></u><br><br>
                    <b>ตัวอย่าง 1</b><br><br>
                    ตัวอย่างนี้เกี่ยวข้องกับสถานการณ์ที่ส่วนต่างของอัตราดอกเบี้ยระหว่างธนาคารสูงกว่าส่วนเพิ่ม ในกรณีดังกล่าว บัญชีของคุณจะถูกเดบิตเมื่อคุณซื้อ (Long) และเครดิตเมื่อคุณขาย (Short):
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                        <li>ตราสาร = EUR/USD (ยูโรเปรียบเทียบกับดอลลาร์สหรัฐฯ)</li>
                        <li>อัตราดอกเบี้ยกลาง 3 เดือน (รายปี) ของ EUR (สกุลเงินพื้นฐาน) = -0.37% = -0.0037</li>
                        <li>อัตราดอกเบี้ยกลาง 3 เดือน (รายปี) ของ USD (สกุลเงินอื่น) = 1.08% = 0.0108</li>
                        <li>ส่วนต่างของอัตราดอกเบี้ยระหว่างธนาคาร = 1.45% = 0.0145</li>
                        <li>ส่วนเพิ่มสถานะ Long = 0.75% = 0.0075</li>
                        <li>ส่วนเพิ่มสถานะ Short = 0.75% = 0.0075</li>
                        <li>มูลค่ายอดการซื้อขายในสกุลเงินอื่น = 106,550 USD (100,000 EUR ที่อัตราปิดปัจจุบันที่ 1.0655)</li>
                    </ul>
                    ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    ค่าธรรมเนียมการถือสถานะข้ามคืน = 106,550 × (-0.0000611) = -6.51 USD ซึ่งหมายถึงค่าธรรมเนียม 6.51 USD ต่อวัน
                    <br><br><br>
                    ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    ค่าธรรมเนียมการถือสถานะข้ามคืน = 106,550 × 0.00001944 = เครดิต 2.07 USD ต่อวัน
                    <br><br><br>
                    <b>ตัวอย่าง 2</b><br><br>
                    ตัวอย่างนี้เกี่ยวข้องกับสถานการณ์ที่ส่วนต่างของอัตราดอกเบี้ยระหว่างธนาคารสูงกว่าส่วนเพิ่ม และส่วนเพิ่มสถานะ Long และ Short แตกต่างกัน ในกรณีดังกล่าว บัญชีของคุณจะถูกเดบิตเมื่อคุณซื้อ (Long) และเครดิตเมื่อคุณขาย (Short):
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>ตราสาร = EUR/TRY (ยูโรเปรียบเทียบกับลีราตุรกี)</li>
                       <li>อัตราดอกเบี้ยกลาง 3 เดือน (รายปี) ของ EUR (สกุลเงินพื้นฐาน) = -0.37% = -0.0037</li>
                       <li>อัตราดอกเบี้ยกลาง 3 เดือน (รายปี) ของ TRY (สกุลเงินอื่น) = 22.75% = 0.2275</li>
                       <li>ส่วนต่างของอัตราดอกเบี้ยระหว่างธนาคาร = 23.12% = 0.2312</li>
                       <li>ส่วนเพิ่มสถานะ Long = 0.75% = 0.0075</li>
                       <li>ส่วนเพิ่มสถานะ Short = 14.00% = 0.14</li>
                       <li>มูลค่ายอดการซื้อขายในสกุลเงินอื่น = 620,000 TRY (100,000 EUR ที่อัตราปิดปัจจุบันที่ 6.2000)</li>
                    </ul>
                    ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):<br><br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        ค่าธรรมเนียมการถือสถานะข้ามคืน = 620,000 × (-0.000663) = -411 TRY ซึ่งหมายถึงค่าธรรมเนียม 411 TRY ต่อวัน (≅80 USD)
                        <br><br><br>
                        ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        ค่าธรรมเนียมการถือสถานะข้ามคืน = 620,000 × (0.000253) = 157 TRY ซึ่งหมายถึงเครดิต 157 TRY ต่อวัน (≅30 USD)
                        <br><br><br>
                        <b>ตัวอย่าง 3</b><br><br>
                        ตัวอย่างนี้เกี่ยวข้องกับสถานการณ์ที่ส่วนต่างของอัตราดอกเบี้ยระหว่างธนาคารต่ำกว่าส่วนเพิ่มที่เป็นลบ ในกรณีดังกล่าว บัญชีของคุณจะถูกเดบิตเมื่อคุณขาย (Short) และเครดิตเมื่อคุณซื้อ (Long):
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>ตราสาร = USD/JPY (ดอลลาร์สหรัฐเปรียบเทียบกับเยนญี่ปุ่น)</li>
                           <li>อัตราดอกเบี้ยกลาง 3 เดือน (รายปี) ของ USD (สกุลเงินพื้นฐาน) = 1.08% = 1.08</li>
                           <li>อัตราดอกเบี้ยกลาง 3 เดือน (รายปี) ของ JPY (สกุลเงินอื่น) = -0.09% = -0.0009</li>
                           <li>ส่วนต่างของอัตราดอกเบี้ยระหว่างธนาคาร = -1.17% = -0.0117</li>
                           <li>ส่วนเพิ่มสถานะ Long = 0.75% = 0.0075</li>
                           <li>ส่วนเพิ่มสถานะ Short = 0.75% = 0.0075</li>
                           <li>มูลค่ายอดการซื้อขายในสกุลเงินอื่น = 10,341,000 JPY (100,000 USD ที่อัตราปิดปัจจุบันที่ 103.41)</li>
                        </ul>
                        ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        ค่าธรรมเนียมการถือสถานะข้ามคืน = 10,341,000 ×0.00001167= เครดิต 120.65 JPY ต่อวัน (≅1.1 USD)
                        <br><br><br>
                        ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        ค่าธรรมเนียมการถือสถานะข้ามคืน = 10,341,000 × (-0.0000533) = -551.52 JPY ซึ่งหมายถึงค่าธรรมเนียม 551.52 JPY ต่อวัน (≅5.3 USD)
                     
                      
                   
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* การชำระหนี้ทางการเงินข้ามคืนอาจใช้เวลาถึง 15 นาทีในการดำเนินการ เมื่อสิ้นสุดวันซื้อขายหลังจากนั้นบัญชีของคุณจะได้รับเครดิตหรือหักบัญชีอย่างเหมาะสม</p>`,
          table_titles: [
            "ตราสาร",
            "ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนต่อวัน (ขาย)",
            "ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนต่อวัน (ซื้อ)",
            "ค่าธรรมเนียมการถือสถานะข้ามคืน (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "CFD ของดัชนี สินค้าโภคภัณฑ์ และสกุลเงินคริปโต",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "ค่าธรรมเนียมการถือสถานะข้ามคืน",
          content_before: `
                        <p>
                        เมื่อทำการซื้อขาย CFD ดัชนี สินค้าโภคภัณฑ์ และ Crypto กับ iFOREX ข้อตกลงที่เปิดอยู่ของคุณจะขึ้นอยู่กับการจัดหาเงินทุนข้ามคืนเมื่อสิ้นสุดแต่ละวันซื้อขาย ยกเว้นตำแหน่งยาวของผลิตภัณฑ์ที่ไม่มีเลเวอเรจซึ่งไม่ถูกเรียกเก็บเงินสำหรับการจัดหาเงินทุนข้ามคืน การจัดหาเงินทุนข้ามคืนนี้อาจได้รับเครดิตหรือเดบิต โดยคำนวณจากอัตราดอกเบี้ยที่เกี่ยวข้องสำหรับสกุลเงินที่มีการซื้อขายตราสารอ้างอิง บวกด้วยมาร์กอัป มาร์กอัป Cryptocurrencies อาจสูงขึ้นอย่างมากเนื่องจากสภาวะตลาดที่รุนแรงของ Cryptocurrencies โปรดตรวจสอบตารางด้านล่างสำหรับระดับการจัดหาเงินทุนข้ามคืนล่าสุด
                        <br><br>
                        หากร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนที่คำนวณได้เป็นบวก นั่นหมายความว่าจะมีการเพิ่มยอดเงินที่เกี่ยวข้อง (เครดิต) เข้าไปในยอดคงเหลือในบัญชีของคุณ ส่วนร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนที่เป็นลบหมายความว่าจะมีการหักยอดเงินที่เกี่ยวข้อง (เดบิต) ออกจากยอดคงเหลือในบัญชีของคุณ
                        <br><br>
                        คุณสามารถดูร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนที่เกี่ยวข้อง ยอดเงิน และเวลาดำเนินการที่เกี่ยวข้องของค่าธรรมเนียมบนทั้งแบบฟอร์ม Deal และ Limit ในแท็บ “ข้อมูลตลาด” หากต้องการคำนวณค่าธรรมเนียมการถือสถานะข้ามคืนที่จะมีการเดบิตหรือเครดิตกับบัญชีของคุณ เพียงนำร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนไปคูณขนาดการซื้อขายของคุณ เวลาดำเนินการของกระบวนการถือสถานะข้ามคืนสำหรับ CFD แต่ละรายการมีรายละเอียดอยู่ใน “เครื่องมือข้อมูลตราสาร” ของแบบฟอร์ม Deal ใต้ “ค่าธรรมเนียมการถือสถานะข้ามคืน (GMT)” ค่าและร้อยละที่คำนวณได้ของค่าธรรมเนียมการถือสถานะข้ามคืนของตราสารหนึ่ง ๆ มีผลเป็นเวลา 1 วัน CFD ที่เทรดสัปดาห์ละ 5 วันจะมีการเครดิตหรือเดบิตด้วยค่าที่แสดงคูณด้วย 3 ในระหว่างวันสุดท้ายของสัปดาห์ซื้อขายของสินทรัพย์อ้างอิงของ CFD เนื่องจากค่านี้ครอบคลุมช่วงเวลาทั้งสุดสัปดาห์ ยอดค่าธรรมเนียมการถือสถานะข้ามคืนจะระบุตามสกุลเงินของ CFD อย่างไรก็ตาม หากสกุลเงินของ CFD ที่ระบุแตกต่างจากสกุลเงินของบัญชี จะมีการแปลงสกุลเงินเป็นสกุลเงินของบัญชี
                        <br><br>
                        <u><b><u>สูตร</u></b></u><br><br>
                        การคำนวณร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):<br>
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">อัตราดอกเบี้ย 3 เดือน+ส่วนเพิ่ม</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                การคำนวณร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">อัตราดอกเบี้ย 3 เดือน-ส่วนเพิ่ม</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                หากต้องการคำนวณยอดค่าธรรมเนียมการถือสถานะข้ามคืน เพียงคูณยอดการซื้อขายด้วยด้วยร้อยละ:<br><br>ยอดค่าธรรมเนียมการถือสถานะข้ามคืน = ยอดการซื้อขาย × ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน
                <br><br><br>
                <u><b><u>ตัวอย่าง</u></b></u><br><br>
                <b>ตัวอย่าง 1</b><br><br>
                ตัวอย่างนี้เกี่ยวข้องกับสถานการณ์ที่อัตราดอกเบี้ยระหว่างธนาคารสูงกว่าส่วนเพิ่ม ในกรณีดังกล่าว บัญชีของคุณจะถูกเดบิตเมื่อคุณซื้อ (Long) และเครดิตเมื่อคุณขาย (Short):
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>ตราสาร = ดัชนี Ibovespa บราซิล</li>
                   <li>อัตราดอกเบี้ย 3 เดือน (รายปี) ของเรียลบราซิล (BRL) = 9.567% = 0.09567</li>
                   <li>ส่วนเพิ่ม Short = 2.5% = 0.025</li>
                   <li>มูลค่ายอดการซื้อขายในสกุลเงิน = 127,380 BRL (สัญญาดัชนี 2 สัญญาที่อัตราปิดปัจจุบันที่ 63,690 BRL ต่อสัญญา)</li>
                </ul>
             
                ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                ค่าธรรมเนียมการถือสถานะข้ามคืน = 127,380 × (-0.0003351944) = -42.70 BRL ซึ่งหมายถึงค่าธรรมเนียม 42.70 BRL ต่อวัน (≅13.58 USD)
                <br><br><br>
                ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                ค่าธรรมเนียมการถือสถานะข้ามคืน = 127,380 ×0.00019630556= เครดิต 25 BRL ต่อวัน (≅7.95 USD)
                <br><br><br>
                <b>ตัวอย่าง 2</b><br><br>
                ตัวอย่างนี้เกี่ยวข้องกับสถานการณ์ที่อัตราดอกเบี้ยระหว่างธนาคารต่ำกว่าส่วนเพิ่ม ในกรณีดังกล่าวบัญชีของคุณจะถูกเดบิตในแต่ละคืนโดยไม่คำนึงถึงว่าสถานะของคุณจะมีทิศทางใดก็ตาม
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>ตราสาร = น้ำมัน (น้ำมันดิบ Light WTI)</li>
                   <li>อัตราดอกเบี้ย 3 เดือน (รายปี) ของดอลลาร์สหรัฐฯ (USD) = 1.08% = 0.0108</li>
                   <li>ส่วนเพิ่ม Short = 2.5% = 0.025</li>
                   <li>มูลค่ายอดการซื้อขายในสกุลเงิน = 53,250 USD (1,000 บาร์เรลที่อัตราปิดปัจจุบันที่ 53.25 USD ต่อบาร์เรล)</li>
                </ul>

                ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):<br><br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    ค่าธรรมเนียมการถือสถานะข้ามคืน = 53,250 × (-0.00009944) = -5.30 USD ซึ่งหมายถึงค่าธรรมเนียม 5.30 USD ต่อวัน
                    <br><br><br>
                    ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):<br><br>

                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                  ค่าธรรมเนียมการถือสถานะข้ามคืน = 53,250 × (-0.00003944) = -2.10 USD ซึ่งหมายถึงค่าธรรมเนียม 2.10 USD ต่อวัน
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* การชำระหนี้ทางการเงินข้ามคืนอาจใช้เวลาถึง 15 นาทีในการดำเนินการ เมื่อสิ้นสุดวันซื้อขายหลังจากนั้นบัญชีของคุณจะได้รับเครดิตหรือหักบัญชีอย่างเหมาะสม</p>`,
          table_titles: [
            "ตราสาร",
            "ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนต่อวัน (ขาย)",
            "ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนต่อวัน (ซื้อ)",
            "ค่าธรรมเนียมการถือสถานะข้ามคืน (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "วันที่โรลโอเวอร์ของสัญญา",
          content_before: `<p>
                            CFD ทุกสัญญาที่อ้างอิงตามสัญญาฟิวเจอร์ส (นั่นคือ สินค้าโภคภัณฑ์และดัชนี) จะมีวันที่โรลโอเวอร์
                            <br><br>
                            เมื่อไถึงวันที่โรลโอเวอร์ของตราสารที่เกี่ยวข้อง สถานะ CFD ของสัญญาฟิวเจอร์สที่เปิดอยู่ทั้งหมดจะถูกโรลโอเวอร์ (ย้ายสถานะ) ไปยังสัญญาถัดไป เพื่อให้สถานะทั้งหมดยังคงเปิดอยู่กับสัญญาฟิวเจอร์สใหม่
                            <br><br>
                            เมื่อการโรลโอเวอร์ดังกล่าวมีผลแล้ว P/L (กำไร/ขาดทุน) ที่เปิดอยู่ของสถานะจะแสดงส่วนต่างราคาระหว่างราคาของสัญญาที่หมดอายุและสัญญาใหม่ และรวมถึงสเปรดของส่วนเพิ่ม ระดับราคา Limit Order ที่เกี่ยวข้องทั้งหมดจะได้รับการปรับค่าตามราคาของสัญญาฟิวเจอร์สสัญญาใหม่โดยอัตโนมัติ
                            <br><br>
                            ตัวอย่างเช่น หากราคาสุดท้ายของสัญญาน้ำมันดิบ WTI เดือนกุมภาพันธ์เท่ากับ $50.125 และราคาตลาดของสัญญาถัดไป (เดือนมีนาคม) ในเวลานั้นเท่ากับ $50.805 ระดับราคาของ Limit Order ที่ยังดำเนินอยู่ที่เกี่ยวข้องทั้งหมดจะได้รับการอัปเดตขึ้นไป $0.68
                            <br><br>
                            วันที่โรลโอเวอร์ของสัญญาขึ้นอยู่กับตราสารที่คุณกำลังเทรด และวันที่ที่ระบุด้านล่างจะเป็นวันที่โรลโอเวอร์เดียวที่ใช้กับ CFD ของ iFOREX:
                            </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["เดือนของสัญญา", "โรลโอเวอร์ของสัญญา (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["สินค้าโภคภัณฑ์", "ดัชนี"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "หุ้นและ ETF CFDs",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "ค่าธรรมเนียมการถือสถานะข้ามคืน",
          content_before: `<p>
                        เมื่อทำการซื้อขาย CFD ของหุ้นและ ETF กับ iFOREX ข้อตกลงที่เปิดอยู่ของคุณจะขึ้นอยู่กับการจัดหาเงินทุนข้ามคืน ณ สิ้นวันซื้อขายแต่ละวัน ยกเว้นตำแหน่งยาวของผลิตภัณฑ์ที่ไม่มีเลเวอเรจซึ่งไม่ถูกเรียกเก็บเงินสำหรับการจัดหาเงินทุนข้ามคืน การจัดหาเงินทุนข้ามคืนนี้อาจได้รับเครดิตหรือเดบิต โดยคำนวณจากอัตราดอกเบี้ยที่เกี่ยวข้องสำหรับสกุลเงินที่มีการซื้อขายตราสารอ้างอิง บวกด้วยมาร์กอัป โปรดตรวจสอบตารางด้านล่างสำหรับระดับการเงินข้ามคืนล่าสุด
                        <br><br>
                        หากร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนที่คำนวณได้เป็นบวก นั่นหมายความว่าจะมีการเพิ่มยอดเงินที่เกี่ยวข้อง (เครดิต) เข้าไปในยอดคงเหลือในบัญชีของคุณ ส่วนร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนที่เป็นลบหมายความว่าจะมีการหักยอดเงินที่เกี่ยวข้อง (เดบิต) ออกจากยอดคงเหลือในบัญชีของคุณ
                        <br><br>
                        คุณสามารถดูร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนที่เกี่ยวข้อง ยอดเงิน และเวลาดำเนินการที่เกี่ยวข้องของค่าธรรมเนียมบนทั้งแบบฟอร์ม Deal และ Limit ในแท็บ “ข้อมูลตลาด” หากต้องการคำนวณค่าธรรมเนียมการถือสถานะข้ามคืนที่จะมีการเดบิตหรือเครดิตกับบัญชีของคุณ เพียงนำร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนไปคูณขนาดการซื้อขายของคุณ เวลาดำเนินการของกระบวนการถือสถานะข้ามคืนสำหรับ CFD แต่ละรายการมีรายละเอียดอยู่ใน “เครื่องมือข้อมูลตราสาร” ของแบบฟอร์ม Deal ใต้ “ค่าธรรมเนียมการถือสถานะข้ามคืน (GMT)” ค่าและร้อยละที่คำนวณได้ของค่าธรรมเนียมการถือสถานะข้ามคืนของตราสารหนึ่ง ๆ มีผลเป็นเวลา 1 วัน CFD ที่เทรดสัปดาห์ละ 5 วันจะมีการเครดิตหรือเดบิตด้วยค่าที่แสดงคูณด้วย 3 ในระหว่างวันสุดท้ายของสัปดาห์ซื้อขายของสินทรัพย์อ้างอิงของ CFD เนื่องจากค่านี้ครอบคลุมช่วงเวลาทั้งสุดสัปดาห์ ยอดค่าธรรมเนียมการถือสถานะข้ามคืนจะระบุตามสกุลเงินของ CFD อย่างไรก็ตาม หากสกุลเงินของ CFD ที่ระบุแตกต่างจากสกุลเงินของบัญชี จะมีการแปลงสกุลเงินเป็นสกุลเงินของบัญชี
                        <br><br>
                        <u><b><u>สูตร</u></b></u><br><br>
                        การคำนวณร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):<br>
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">อัตราดอกเบี้ย 3 เดือน+ส่วนเพิ่ม</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                การคำนวณร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):
                <br>
                <br>

                <div class="formula formula_f16 mb-4">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">อัตราดอกเบี้ย 3 เดือน-ส่วนเพิ่ม</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                หากต้องการคำนวณยอดค่าธรรมเนียมการถือสถานะข้ามคืน เพียงคูณยอดการซื้อขายด้วยด้วยร้อยละ:<br><br>ยอดค่าธรรมเนียมการถือสถานะข้ามคืน = ยอดการซื้อขาย × ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน
                <br><br><br>
                <u><b><u>ตัวอย่าง</u></b></u><br><br>
                <b>ตัวอย่าง 1</b><br><br>
                ตัวอย่างนี้เกี่ยวข้องกับสถานการณ์ที่อัตราดอกเบี้ยระหว่างธนาคารสูงกว่าส่วนเพิ่ม ในกรณีดังกล่าว บัญชีของคุณจะถูกเดบิตเมื่อคุณซื้อ (Long) และเครดิตเมื่อคุณขาย (Short):
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>ตราสาร = Gazprom (GAZP)</li>
                   <li>อัตราดอกเบี้ย 3 เดือน (รายปี) ของรูเบิลรัสเซีย (RUB) = 9.5% = 0.095</li>
                   <li>ส่วนเพิ่ม Short = 5% = 0.05</li>
                   <li>มูลค่ายอดการซื้อขายในสกุลเงิน = 2,459,000 RUB (20,000 หุ้นที่อัตราปิดปัจจุบันที่ 122.95 RUB ต่อหุ้น)</li>
                </ul>

                ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):<br><br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                ค่าธรรมเนียมการถือสถานะข้ามคืน = 2,459,000 × (-0.0004) = -983.60 RUB ซึ่งหมายถึงค่าธรรมเนียม 983.60 RUB ต่อวัน (≅17.52 USD)
                <br><br><br>
                ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                ค่าธรรมเนียมการถือสถานะข้ามคืน = 2,459,000 ×0.000125= เครดิต 307.38 RUB ต่อวัน (≅5.48 USD)
                <br><br><br>
                <b>ตัวอย่าง 2</b><br><br>
                ตัวอย่างนี้เกี่ยวข้องกับสถานการณ์ที่อัตราดอกเบี้ยระหว่างธนาคารต่ำกว่าส่วนเพิ่ม ในกรณีดังกล่าวบัญชีของคุณจะถูกเดบิตในแต่ละคืนโดยไม่คำนึงถึงว่าสถานะของคุณจะมีทิศทางใดก็ตาม
                <br><br>
                <ul class="list-style-dashed">
                    <li>ตราสาร = Apple (AAPL)</li>
                    <li>อัตราดอกเบี้ย 3 เดือน (รายปี) ของดอลลาร์สหรัฐฯ (USD) = 1.08% = 0.0108</li>
                    <li>ส่วนเพิ่ม Short = 5% = 0.05</li>
                    <li>มูลค่ายอดการซื้อขายในสกุลเงิน = 70,600 USD (500 หุ้นที่อัตราปิดปัจจุบันที่ 141.20 USD ต่อหุ้น)</li>
                </ul>
                <br>
                ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณซื้อ (สถานะ Long):<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                ค่าธรรมเนียมการถือสถานะข้ามคืน = 70,600 × (-0.000169) = -11.93 USD ซึ่งหมายถึงค่าธรรมเนียม 11.93 USD ต่อวัน
                <br><br><br>
                ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนเมื่อคุณขาย (สถานะ Short):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืน</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                ค่าธรรมเนียมการถือสถานะข้ามคืน = 70,600 × (-0.000109) = -7.70 USD ซึ่งหมายถึงค่าธรรมเนียม 7.70 USD ต่อวัน
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* การชำระหนี้ทางการเงินข้ามคืนอาจใช้เวลาถึง 15 นาทีในการดำเนินการ เมื่อสิ้นสุดวันซื้อขายหลังจากนั้นบัญชีของคุณจะได้รับเครดิตหรือหักบัญชีอย่างเหมาะสม</p>`,
          table_titles: [
            "ตราสาร",
            "ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนต่อวัน (ขาย)",
            "ร้อยละค่าธรรมเนียมการถือสถานะข้ามคืนต่อวัน (ซื้อ)",
            "ค่าธรรมเนียมการถือสถานะข้ามคืน (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "เงินปันผล",
          content_before: `<p>
                        ในกรณีของการจ่ายเงินปันผลเป็นเงินสดที่เกี่ยวข้องกับ CFD ของหุ้น การปรับเงินปันผลจะทำในยอดคงเหลือของลูกค้าตามตำแหน่ง CFD ของหุ้นอ้างอิงที่ลูกค้าถืออยู่เมื่อสิ้นสุดวันทำการก่อนวันจ่ายเงินปันผล การปรับเงินปันผลจะคำนวณตามขนาดของเงินปันผล ขนาดของตำแหน่งของลูกค้า และไม่ว่าจะเป็นธุรกรรมซื้อหรือขาย ในตำแหน่งยาว การปรับจะถูกโอนไปยังยอดคงเหลือของลูกค้า และในตำแหน่งสั้น การปรับจะถูกหักออกจากยอดคงเหลือของลูกค้า เงินปันผลจะได้รับการเครดิตหรือหักจากยอดคงเหลือของลูกค้านอกเวลาซื้อขายของหุ้นอ้างอิงและก่อนการเปิดการซื้อขายวันถัดไปของหุ้น และขึ้นอยู่กับลูกค้าที่ดำรงตำแหน่งของตนในเวลาที่มีการปรับเงินปันผล ในช่วงเวลานี้ เพื่อรักษามูลค่ายุติธรรมของทุนของลูกค้าไว้จนกว่าจะเปิดการซื้อขายวันถัดไป บริษัทจะปรับตำแหน่งของลูกค้าตามจำนวนเงินปันผลที่เดบิตหรือเครดิตจากยอดคงเหลือของลูกค้า
                        <br><br>
                        <u>ตัวอย่าง:</u><br>
                        Coca-Cola จ่ายเงินปันผล 0.35 USD ต่อหุ้น<br>
                        วันที่ซื้อหุ้นไม่ได้รับเงินปันผล (ex-dividend date) คือวันที่ 29 พฤศจิกายนและวันชำระราคา (settlement date) ใน iFOREX คือวันที่ 28 พฤศจิกายน เวลา 22:05 น. ตามเขตเวลา GMT<br>
                        ราคาปิดก่อนการชำระราคาคือ 41.65<br>
                        ลูกค้าที่ถือสถานะ Long ของหุ้น 5,000 หุ้นจะได้รับการเครดิตเป็นจำนวน 0.35 x 5,000 = 1,750 USD หากการซื้อขายนี้เปิดอยู่ในวันชำระราคา
                        <br>
                        หากลูกค้าถือสถานะ Short ยอดที่คล้ายกันจะถูกหักออกจากยอดคงเหลือของบัญชีเทรดของลูกค้ารายดังกล่าว
                        <br>
                        ราคาหุ้นจะได้รับการปรับในระหว่างหลังชั่วโมงทำการ จาก 41.65 เป็น 41.30 ซึ่งเท่ากับราคาหุ้นล่าสุดลบด้วยยอดเงินปันผล
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"ตอนนี้ยังไม่มีข้อมูลเกี่ยวกับการจ่ายเงินปันผลในอนาคต",
          table_titles: [
            "หุ้น / ETF",
            "ตลาด",
            "จำนวนเงินปันผล",
            "วันที่และเวลา (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "การแตกหุ้นและการดำเนินการอื่น ๆ ของบริษัท",
          content_before: `<p>
          การดำเนินการขององค์กรเหตุการณ์บางอย่างที่ส่งผลต่อมูลค่าหุ้นของบริษัทมหาชน เว้นแต่ระบุไว้เป็นอย่างอื่นในเอกสารนี้เกี่ยวกับการดำเนินการของบริษัทที่เฉพาะเจาะจง เมื่อเกิดการดำเนินการของบริษัทในหุ้นที่เฉพาะเจาะจง iFOREX จะชำระบัญชีสถานะที่เปิดอยู่ใด ๆ ของ CFD ที่เกี่ยวข้อง ซึ่งรวมถึงการนำคำสั่ง Limit Order ใด ๆ ของ CFD ดังกล่าวออกเมื่อจำเป็น
          <br><br>
          การดำเนินการของบริษัทใน iFOREX รวมถึงการ การเสนอขายหุ้นให้ผู้ถือหุ้นตามสัดส่วน การเพิกถอนจากตลาด และเหตุการณ์อื่นใดที่อาจส่งผลกระทบอย่างสำคัญต่อ หรืออาจส่งผลกระทบอย่างสำคัญต่อราคาของหุ้น (ซึ่งรวมถึงการประกาศที่สำคัญของบริษัท การเข้าครอบครองกิจการ (เทคโอเวอร์) การควบรวมกิจการ การมีหนี้สินล้นพ้นตัว เป็นต้น)
            <br><br>

            

            <b>กฎที่เฉพาะเจาะจงเกี่ยวกับการแตกหุ้นและการรวมหุ้น</b><br>
            การแตกหุ้นและการรวมหุ้นในตลาดหลักทรัพย์ไม่ได้เปลี่ยนแปลงมูลค่าทั้งหมดของหุ้นสำหรับผู้ที่ถือหุ้นนั้น แต่เปลี่ยนแปลงจำนวนหุ้นและราคาของหุ้นนั้น การแตกหุ้นและการรวมหุ้นเช่นนี้มักใช้เมื่อราคาหุ้นสูงหรือต่ำเกินไป หากสัญญา/Limit ที่เปิดอยู่เจอกับสถานการณ์การแตกหุ้นหรือรวมหุ้น จำนวน อัตรา และระดับ Limit ที่เกี่ยวข้องจะถูกปรับเปลี่ยนอย่างสอดคล้อง (รวมถึงยอดคงเหลือของบัญชีเนื่องจากการปรับ PL ถ้าเกี่ยวข้อง)
                <br><br>
                ตัวอย่างเช่น ในการแตกหุ้น 1:10 หุ้น 1 หุ้นจะกลายเป็น 10 หุ้นหลังจากเหตุการณ์นี้ ส่วนราคาจะถูกหารด้วย 10 ทำให้มูลค่าโดยรวมของหุ้นไม่เปลี่ยนแปลง เช่น หุ้น 1 หุ้นที่มีราคา $1,000 จะกลายเป็นหุ้น 10 หุ้นที่มีราคา $100 หลังจากเหตุการณ์นี้: 1x $1,000 = 10 x$100 = มูลค่า $1,000
                <br><br>
                โปรดดูรายการการดำเนินการของบริษัทที่กำลังจะมาถึงด้านล่าง
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"ณ ปัจจุบันยังไม่มีข้อมูลเกี่ยวกับการดำเนินการในอนาคตของบริษัท",
          table_titles: ["หุ้น / ETF", "ตลาด", "ประเภท", "	วันที่และเวลา (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "รายงานรายได้",
          content_before: `<p>
                            An earnings report is a periodic filing made by public companies to report their performance. By analyzing quarterly earnings reports, investors can analyze the financial health of the company. The announcement of earnings for a company, particularly for a popular company with a high market capitalization, can affect its share prices, which can cause it to fluctuate widely on days when such quarterly earnings reports are released.
                                  <br><br>
                                  For that reason, maximum exposure of the relevant shares will be lowered to $10,000 throughout the period of publication.
                            </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  